import { motion } from 'framer-motion';

export const SellCard = ({ 
  icon: Icon, 
  title, 
  description,
  index = 0
}) => {
  return (
    <motion.div 
      data-testid="sell-card"
      className="p-8 rounded-2xl bg-white/[0.03] border border-white/5 flex flex-col items-start gap-4 transition-all duration-300 hover:-translate-y-2 hover:border-[#00A3FF]/30 hover:shadow-[0_10px_30px_rgba(0,163,255,0.1)]"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.15 }}
    >
      <div className="w-14 h-14 rounded-xl bg-[#00A3FF]/10 flex items-center justify-center">
        <Icon className="w-7 h-7 text-[#00A3FF]" />
      </div>
      <h3 className="text-xl md:text-2xl font-bold text-white">{title}</h3>
      <p className="text-base text-gray-400 leading-relaxed">{description}</p>
    </motion.div>
  );
};

export default SellCard;
